const objectives = {
  objectives: {
    cycles: {
      title: "Ciclos de Objetivos",
      createNew: "Criar Novo Ciclo",
      viewDetails: "Ver Detalhes",
      noResults: "Nenhum ciclo de objetivos encontrado",
      backToList: "Voltar para Ciclos",
    },
    status: {
      scheduled: "Agendado",
      active: "Ativo",
      finished: "Finalizado",
    },
    cycle: {
      name: "Nome",
      status: "Status",
      createdAt: "Criado em",
      period: "Período",
      assignations: "Atribuições",
      completion: "Conclusão",
      actions: "Ações",
      startDate: "Data de início",
      endDate: "Data de término",
      namePlaceholder: "Digite o nome do ciclo",
      startDatePlaceholder: "Selecione a data de início",
      endDatePlaceholder: "Selecione a data de término",
      startDateError: "A data de início não pode ser anterior a hoje",
      endDateError: "A data de término não pode ser anterior à data de início",
      uploadAssignations: "Carregar Atribuições",
      exportAssignations: "Exportar",
      time: "Hora",
    },
    assignation: {
      user: "Usuário",
      email: "E-mail",
      objective: "Objetivo",
      status: "Status",
      viewDetails: "Ver Detalhes",
      noAssignations: "Nenhuma atribuição ainda",
      noAssignationsDescription:
        "Carregue um arquivo Excel com atribuições para começar",
      uploadDescription:
        "Carregue um arquivo Excel com atribuições para este ciclo.",
      formatTitle: "Formato de Excel Necessário",
      formatDescription: "O arquivo Excel deve ter o seguinte formato:",
      formatExample:
        "Coluna A: avaliador@exemplo.com | Coluna B: avaliado@exemplo.com",
      formatNote:
        "Coloque os e-mails dos avaliadores na coluna A e os e-mails dos avaliados na coluna B da sua planilha Excel.",
      changeFile: "Alterar Arquivo",
      dragAndDrop: "Arraste e solte o arquivo aqui, ou",
      browseFiles: "Procurar Arquivos",
      excelOnly: "Apenas arquivos Excel (.xlsx, .xls)",
      uploadResults: "Resultados do Upload",
      uploadResultsSummary:
        "Processadas {total} atribuições: {success} bem-sucedidas, {errors} erros",
      uploadResultsSuccess: "Sucesso",
      uploadResultsErrors: "Erros",
      uploadResultsClose: "Fechar",
      uploadResultsRetry: "Tentar Novamente",
      uploadResultsNoErrors:
        "Todas as atribuições foram processadas com sucesso!",
      chooseUploadMethod:
        "Escolha como gostaria de adicionar atribuições a este ciclo",
      uploadViaSpreadsheet: "Carregar Planilha",
      uploadManually: "Adicionar Manualmente",
      spreadsheetDescription:
        "Carregue um arquivo Excel com múltiplas atribuições de uma vez",
      manualDescription: "Crie atribuições uma por uma usando um formulário",
      bulk: "Carregamento em Massa",
      precise: "Controle Preciso",
      back: "Voltar",
      comingSoon: "Em Breve",
      manualFeatureDescription:
        "A criação manual de atribuições estará disponível em uma atualização futura.",
      manual: {
        description:
          "Crie atribuições individuais selecionando um atribuidor e os usuários que ele avaliará.",
        assignor: "Atribuidor",
        selectAssignor: "Selecionar atribuidor...",
        assignorHelp: "A pessoa que criará e gerenciará objetivos para outros",
        assignorRequired: "Por favor selecione um atribuidor",
        receivers: "Colaboradores para Avaliar",
        selectReceivers: "Selecionar colaboradores...",
        receiversHelp:
          "Selecione uma ou mais pessoas que receberão objetivos do atribuidor",
        receiversRequired: "Por favor selecione pelo menos um receptor",
        selectedCount: "colaborador(es) selecionado(s)",
        createAssignments: "Criar Atribuições",
        creating: "Criando...",
        cancel: "Cancelar",
        success: "Atribuições criadas com sucesso",
        error: "Erro ao criar atribuições",
        summary: "Resumo da Atribuição",
        willAssignTo: "atribuirá objetivos para",
        collaborators: "colaborador(es)",
        duplicateInfo:
          "Nota: Se já existir uma atribuição entre o atribuidor e receptor selecionados para este ciclo, ela não será criada novamente.",
      },
      sender: "Atribuidor",
      receiver: "Colaborador",
      objectivesCount: "Objetivos",
      objectivesDetails: "Detalhes dos Objetivos",
      objectives: "Objetivos",
      noObjectives: "Nenhum objetivo encontrado para esta atribuição.",
      ponderation: "Ponderação",
      target: "Meta",
      tabs: {
        total: "Total",
        withObjectives: "Com Objetivos",
        withoutObjectives: "Sem Objetivos",
        details: "Detalhes",
        history: "Histórico de Alterações",
      },
      reminders: {
        sendReminder: "Enviar Lembrete",
        confirmationTitle: "Enviar Lembrete",
        confirmationMessage:
          "Tem certeza de que deseja enviar um lembrete para todas as atribuições sem objetivos?",
        cancel: "Cancelar",
        confirm: "Enviar",
        success: "Lembretes enviados com sucesso",
        error: "Erro ao enviar lembretes",
      },
      delete: {
        title: "Excluir Atribuição",
        message: "Tem certeza que deseja excluir esta atribuição?",
        warning: "Esta ação é irreversível e não pode ser desfeita.",
        confirm: "Excluir",
        cancel: "Cancelar",
        success: "Atribuição excluída com sucesso",
      },
    },
    filters: {
      all: "Todos",
      scheduled: "Agendados",
      active: "Ativos",
      finished: "Finalizados",
    },
    edit: {
      edit: "Editar",
      save: "Salvar",
      cancel: "Cancelar",
      title: "Título",
      ponderation: "Ponderação (%)",
      type: "Tipo",
      targetValue: "Valor Alvo",
      deadline: "Prazo",
      ponderationError: "A ponderação total deve ser igual a 100%",
      ponderationWarning: "A ponderação total deve ser igual a 100%",
      saveSuccess: "Objetivos salvos com sucesso",
    },
    types: {
      number: "Número",
      money: "Dinheiro",
      boolean: "Sim/Não",
      "1_to_5": "Escala (1-5)",
    },
    history: {
      title: "Histórico de Alterações",
      noChanges: "Nenhum histórico de alterações disponível.",
      fetchError: "Erro ao buscar histórico de alterações",
      objectiveChange: "Objetivo {number}: {field}",
      changedBy: "Alterado por",
      unknownUser: "Usuário Desconhecido",
    },
  },
};

export default objectives;
